import { render, staticRenderFns } from "./RelatorioCampanhasWhatsapp.vue?vue&type=template&id=b8ac73fa"
import script from "./RelatorioCampanhasWhatsapp.vue?vue&type=script&lang=js"
export * from "./RelatorioCampanhasWhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8ac73fa')) {
      api.createRecord('b8ac73fa', component.options)
    } else {
      api.reload('b8ac73fa', component.options)
    }
    module.hot.accept("./RelatorioCampanhasWhatsapp.vue?vue&type=template&id=b8ac73fa", function () {
      api.rerender('b8ac73fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/RelatorioCampanhasWhatsapp.vue"
export default component.exports